module.exports = {
    Lang: {
        de: 'Alemão',
        en: 'Inglês',
        es: 'Espanhol',
        fr: 'Francês',
        pt: 'Português',
        it: 'Italiano',
        ru: 'Russo'
    },
    Action: {
        add: 'Adicionar',
        edit: 'Processar',
        remove: 'Apagar pedido',
        close: 'Fechar',
        select: 'Selecione',
        save: 'Guardar',
        saving: 'É salvo',
        send: 'Enviar',
        confirmSelection: 'Selecção confirmada',
        change: 'Alterar',
        changeSelection: 'Modificar seleção',
        next: 'Avançar',
        prev: 'Regressar',
        finish: 'Concluído',
        'search': 'Pesquisa'
    },
    Common: {
        start: 'Início',
        date: 'Data',
        creationdate: 'Data de criação',
        lastmodified: 'Última alteração',
        status: 'Estado',
        color: 'Cor',
        settings: 'Configurações',
        masterdata: 'Dados existentes',
        masterdataSaved: 'Os dados mestre foram gravados',
        amount: 'Montante',
        description: 'Descrição',
        item: 'Artigo',
        itemNum: 'N.º do artigo',
        itemName: 'Nome do artigo',
        itemPrice: 'Preço do artigo',
        quantity: 'Número',
        singlePrice: 'Preço unitário',
        discount: 'Desconto',
        rebate: 'Desconto',
        vat: 'IVA',
        total: 'Total',
        orderPrice: 'Preço do pedido',
        annotation: 'Nota',
        accountDetails: 'Informações do cliente',
        customerNum: 'Número de cliente',
        salutation: 'Forma de tratamento',
        firstname: 'Nome',
        lastname: 'Apelido',
        company: 'Empresa',
        email: 'E-mail',
        contact: 'Morada',
        address: 'Endereço',
        postalcode: 'Código postal',
        city: 'Cidade',
        country: 'País',
        taxDetails: 'Informações fiscais',
        vatId: 'Número de IVA',
        noEntries: 'Nenhuma entrada',
        languageSettings: 'Configurações de idioma',
        showXtoYentries: 'Apresentação {x} até {y} Resultados',
        showXtoYofZentries: 'Mostrar {x} a {y} de {z} Resultados',
        errorSavingMasterdata: 'Os dados mestre não puderam ser salvos.',
        errorIncomplete: 'Formulário incompleto',
        errorFieldMissing: '{field} deve ser preenchido',
        errorUploadInvalidResp: 'Resposta inválida do servidor. Por favor, tente novamente ou entre em contato com nosso suporte.',
        noSelection: 'Sem seleção'
    },
    Units: {
        C62: 'pcs.',
        GRM: 'g'
    },
    Dashboard: {
        title: 'Painel de instrumentos'
    },
    Addresses: {
        title: 'Endereços',
        add: 'novo endereço',
        addressMain: 'Endereço principal',
        addressBilling: 'Endereço para faturamento',
        addressShipping: 'Endereço de entrega',
        confirmRemove: 'Você realmente quer remover o contato?',
        errorLoad: 'Os endereços não podiam ser carregados.',
        errorRemove: 'O endereço não pôde ser apagado.'
    },
    EditAddress: {
        title: 'novo endereço',
        errorTypeTitle: 'Por favor, defina um tipo de endereço.',
        errorTypeText: 'O endereço deve ser uma morada de entrega e/ou factura.',
        errorCreate: 'O endereço não pôde ser criado.',
        errorUpdate: 'O endereço não pôde ser atualizado.',
        shipping: 'entregas',
        useForShippingNo: 'Não usar como endereço de entrega.',
        useForShippingYes: 'Utilizar como endereço de entrega',
        useForShippingDefault: 'Usar como endereço de entrega padrão',
        billing: 'Facturas',
        useForBillingNo: 'Não utilizar como endereço de facturação',
        useForBillingYes: 'Utilizar como endereço de facturação',
        useForBillingDefault: 'Use como endereço de faturamento padrão'
    },
    Projects: {
        title: 'Relatórios',
        loading: 'Os relatórios são carregados',
        currentProjects: 'Relatórios atuais',
        showAll: 'Mostrar todos os relatórios',
        noProjects: 'Sem relatórios',
        add: 'Novo relatório',
        projectNumber: 'Relatório nº.',
        projectName: 'ID do doente',
        projectType: 'Tipo de relatório',
        statusAll: 'Todos os relatórios',
        statusOpen: 'Relatórios abertos',
        statusOrdered: 'Relatórios Encomendados',
        errorNoName: 'Insira o nome do relatório.',
        errorCreate: 'O relatório não pôde ser criado.',
        errorCouldNotLoad: 'Os relatórios não puderam ser carregados.'
    },
    ProjectDetails: {
        title: 'Dados do pedido',
        loading: 'O relatório é carregado',
        alertOrdered: 'Relatório ordenado',
        openOrder: 'Ordem em aberto',
        alertReference: 'Este projecto está ligado a outro projecto:',
        openProject: 'Relatório aberto',
        toothSelection: 'selecção dentária',
        noConstruction: 'Keine Konstruktion festgelegt!',
        editConstruction: 'Kontruktion bearbeiten',
        materialSelection: 'Materialauswahl',
        estimatedDelivery: 'Vorauss. Lieferdatum',
        missingMaterial: 'Materialauswahl fehlt',
        missingAttachments: 'Anexos em falta:',
        addStl: 'STL hinzufügen',
        openCart: 'Para o carrinho de compras',
        emptyCart: 'Cesto vazio',
        shippingType: 'Método de envio',
        construction: 'Konstruktion',
        stlUpload: 'STL Upload',
        attachments: 'Anexos',
        addons: 'Produtos adicionais',
        cart: 'Cesto',
        addItem: 'Introduzir artigo',
        orderProject: 'Encomenda vinculativa',
        statusNotOrdered: 'Ainda não efetuou o pedido',
        statusOrdered: 'Encomendas',
        errorNoProjectnum: 'Nenhum número de relatório válido transferido',
        costs: 'Custos do projeto',
        removed: 'Remover projeto',
        removing: 'Projeto é removido',
        saved: 'Projeto guardado',
        saving: 'Projeto é salvo',
        orderSuccessful: 'Encomendar com sucesso'
    },
    Orders: {
        title: 'Encomendas',
        loading: 'As encomendas são carregadas',
        currentOrders: 'Encomendas actuais',
        openOrder: 'Ordem em aberto',
        showAll: 'Mostrar todos os pedidos',
        noOrders: 'Sem ordens',
        orderNum: 'Pedido n.º',
        projectRef: 'Referência do projeto',
        statusAll: 'Todos os pedidos',
        errorCouldNotLoad: 'As encomendas não puderam ser carregadas',
        statusNotOrdered: 'Ainda não efetuou o pedido',
        statusReceived: 'Introduzido',
        statusCancelled: 'Eliminado',
        statusReceivedDescr: 'O pedido é verificado',
        statusInProgress: 'Em processo',
        statusInProgressDescr: 'O seu pedido está sendo processado',
        statusInProduction: 'Em produção',
        statusInProductionDescr: 'A produção já começou',
        statusDelivered: 'Enviado para',
        statusDeliveredDescr: 'O seu pedido foi enviado'
    },
    Reports: {
        statusAll: 'Todos os relatórios',
        statusReceived: 'Dados disponibilizados',
        statusReceivedDescr: 'A encomenda está a ser verificada',
        statusInProgress: 'Em processamento',
        statusInProgressDescr: 'As suas informações estão a ser processadas.',
        statusInProduction: 'Relatório criado',
        statusInProductionDescr: 'O seu modelo de relatório é criado',
        statusOnHold: 'Conteúdo',
        statusCancelled: 'Eliminado',
        statusCancelledDescr: 'O seu pedido foi cancelado.',
        statusClosed: 'Criar relatório',
        statusCompleted: 'Criar relatório',
        statusCompletedDescr: 'Criou um relatório',
        statusInvoicedCancelled: 'Teilberechnet / Storniert',
        statusPartlyDelivered: 'Teilgeliefert',
        statusPartlyDeliveredCancelled: 'Teilgeliefert / Storniert',
        statusPartlyDeliveredClosed: 'Teilgeliefert / Geschlossen',
        statusDelivered: 'Criar relatório',
        statusDeliveredDescr: 'O seu relatório está completo',
        statusReadyForPickup: 'Pronto para a coleta',
    },
    OrderDetails: {
        title: 'Dados do pedido',
        deliveryNote: 'Nota de entrega',
        loading: 'O pedido é carregado',
        trackingNum: 'Número de rastreamento.',
        manufacturingStatus: 'Status de produção',
        trackingAndBilling: 'Rastreamento e faturamento',
        creatingOrder: 'A ordem é criada',
        orderProject: 'Encomenda vinculativa',
        placeOrder: 'Concluir encomenda',
        acceptTerms: 'Li e aceito os <a href="{termsUrl}" target="_blank">termos e condições gerais</a>.',
        errorNoOrderNum: 'Nenhum número de ordem válido transferido',
        errorCouldNotLoad: 'O pedido não pôde ser carregado',
        priceNobleMetal1: 'Der Endgültige Produktpreis ist bei Edelmetallen vom endgültigen Gewicht abhängig.',
        priceNobleMetal2: 'Bitte prüfen Sie hierzu Ihren Lieferschein, sobald der Auftrag abgeschlossen ist.',
        files: 'Ficheiros'
    },
    Messages: {
        title: 'Notícias',
        noMessages: 'Keine Nachrichten',
        errorCouldNotLoad: 'Nachrichten konnte nicht geladen werden',
        writeSomething: 'Schreiben Sie was...',
        errorSendingMessage: 'Nachricht konnte nicht gesendet werden.'
    },
    Configurator: {
        selectIndication: 'Indikation wählen',
        changeMaterial: 'Material ändern',
        selectTooth: 'Bitte wählen Sie einen Zahn',
        showToothNumbers: 'Zahnnummern anzeigen',
        toothSelection: 'Zahnauswahl',
        setProductProps: 'Produkteigenschaften festlegen',
        selectProduct: 'Produkt wählen',
        fileXofY: 'Datei {x} von {y}',
        calcPrice: 'Preise werden berechnet',
        uploadStl: 'STL hochladen',
        stlCount: 'Einheitenanzahl der obigen STL',
        stlCountTooltip: 'Bitte Einheitenanzahl der STL-Datei angeben, z.B. 3 Einheiten bei dreigliedriger Brücke',
        oneUnit: 'Eine Einheit',
        nUnits: '{n} Einheiten',
        removeJawSelection: 'Wollen sie die bestehende Auswahl in diesem Kiefer entfernen?',
        invalidTeethInRange: 'The {0} teeth is invalid for range {1}-{2}.',
        invalidRange: 'The {0}-{1} tooth range is invalid. The start/end teeth have to be on the same jaw.',
        invalidTeethNumber: 'The {0} is invalid teeth number.',
        transferSettings: 'Do you want to transfer those settings to multiple teeth?',
        clickOnConnectTooth: 'Click on the tooth you want to connect to'
    },
    Invoices: {
        title: 'Rechnungen',
        loading: 'Rechnungen werden geladen',
        invoiceNum: 'Rechnung Nr.',
        monthlyStatement: 'Monatsaufstellung',
        statusReceived: 'Eingegangen',
        statusOpen: 'Offen',
        statusHold: 'Gehalten',
        statusCancelled: 'Storniert',
        statusClosed: 'Geschlossen',
        statusPartlyPaid: 'Teilbezahlt',
        statusPartlyPaidCancelled: 'Teilbezahlt / Storniert',
        statusPartlyPaidClosed: 'Teilbezahlt / Geschlossen',
        statusPaid: 'Bezahlt'
    },
    File: {
        name: 'Nome do ficheiro',
        hash: 'Arquivo de haxixe',
        size: 'Tamanho dos ficheiros',
        messageUpload: 'Clicar para efetuar o carregamento ou deslocar os ficheiros para o campo.',
        allFilesSameMaterial: 'Alle Dateien haben das gleiche Material',
        sendingData: 'Os dados são transmitidos',
        processingData: 'Os dados são processados',
        errorUpload: 'Ocorreu um erro. Infelizmente, o arquivo não pôde ser carregado.',
        errorCouldNotList: 'Os ficheiros não podiam ser carregados.',
        errorCouldNotLoad: 'O arquivo não pôde ser carregado.',
        errorCouldNotDelete: 'O arquivo não pôde ser removido.'
    },
    Login: {
        username: 'E-mail ou número de cliente',
        password: 'Palavra-passe',
        passwordOld: 'Senha antiga',
        passwordNew: 'Nova senha',
        passwordConfirm: 'Confirmar nova senha',
        passwordSaved: 'Senha salva',
        login: 'Início de sessão',
        logout: 'Terminar a sessão',
        enterPwd: 'Introduza uma palavra-passe',
        invalidUserOrPwd: 'Nome de utilizador/ palavra-passe inválida',
        errorCouldNotUpdate: 'A senha não pôde ser salva.',
        errorPasswordNoMatch: 'As senhas não coincidem.',
        errorOldPassword: 'A senha antiga está errada.',
        errorNoSession: 'Nenhuma sessão de usuário encontrada. Por favor, faça o login.'
    },
    Infothek: {
        title: 'Infoteca'
    }
};
